export const formatSearchText = (text) => {
  // Replace hyphen symbols and double spaces if any
  return (text || '').replace(/-/g, ' ').replace(/  +/g, ' ');
};
